// extracted by mini-css-extract-plugin
export default {"githubDiv":"GitHub_githubDiv__bkHWn","GitHubCalendar":"GitHub_GitHubCalendar__gPGeY"};